module.exports = __webpack_public_path__ + "media/images/pc/stores/tachikawa/tachikawa_concept_03-558e585fdc449b894edab2100aacd97b.jpg";